import React from 'react'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

const AdultStatus = ({ adult, type, relationship, reupRequired }) => {
  return (
    <Box pb={2} width='100%'>
      <Typography mt={1} variant='h3'>
        {adult.firstName} {adult.lastName}
      </Typography>
      {type && (
        <Typography
          color='text.primary'
          variant='body1'
          textTransform='capitalize'
        >
          {type}
        </Typography>
      )}
      {relationship && (
        <Typography
          color='text.secondary'
          variant='body1'
          textTransform='capitalize'
        >
          {relationship.replace('_', ' ')}
        </Typography>
      )}
      {reupRequired && (
        <Typography
          color='text.secondary'
          variant='body1'
          textTransform='capitalize'
        >
          {adult.confirmed
            ? `Confirmed for ${adult.confirmedForYear}`
            : 'Not Confirmed'}
        </Typography>
      )}
    </Box>
  )
}

export default AdultStatus
